/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The data returned after a successful signup.
 * @export
 * @interface SignupResponse
 */
export interface SignupResponse {
    /**
     * The tenant idt.
     * @type {string}
     * @memberof SignupResponse
     */
    tenantId: string;
}

/**
 * Check if a given object implements the SignupResponse interface.
 */
export function instanceOfSignupResponse(value: object): value is SignupResponse {
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    return true;
}

export function SignupResponseFromJSON(json: any): SignupResponse {
    return SignupResponseFromJSONTyped(json, false);
}

export function SignupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignupResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenant_id'],
    };
}

export function SignupResponseToJSON(json: any): SignupResponse {
    return SignupResponseToJSONTyped(json, false);
}

export function SignupResponseToJSONTyped(value?: SignupResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenant_id': value['tenantId'],
    };
}

